import React, { Component } from 'react';
import { observer } from 'mobx-react';
import moment from 'moment';
import {
  ListGroup,
  ListGroupItem,
  Grid,
  Col,
  Row,
  Label,
} from 'react-bootstrap';
import IconHandPeace from 'react-icons/lib/fa/history';

import { Action } from '../../models/Log';

import './LogList.css';

const LogList = observer(
class LogList extends Component {
  render() {
    let {
      onListItemClick,
      logs = []
    } = this.props;

    if (logs.length === 0) {
      return this.renderEmptyState();
    }

    let LogListItems = logs.map((log) => {
      return (
        <LogListItem
          key={log.id}
          log={log}
          onClick={onListItemClick} />
      );
    });

    return (
      <ListGroup className="LogList-container">
        {LogListItems}
      </ListGroup>
    );
  }

  renderEmptyState = () => {
    return (
      <div className="LogList-empty">
        <div className="LogList-empty-icon"><IconHandPeace /> </div>
        <div className="LogList-empty-text">No recent activities</div>
      </div>
    );
  }
});

const LogListItem = observer(
class LogListItem extends Component {
  render() {
    const log = this.props.log || {};
    const containerClass = "LogListItem-container LogListItem-" + (log.enabled ? "enabled" : "disabled");
    const time = moment(log.timestamp).local().calendar();
    return (
      <ListGroupItem className={containerClass} onClick={this.onClick} >
        <Grid fluid>
          <Row>
            <Col xs={8} sm={4}>{time}</Col>
            <Col xs={4} sm={2}>{this.renderActionLabel(log.action)}</Col>
            <Col xs={12} sm={6}>{log.message}</Col>
          </Row>
        </Grid>
      </ListGroupItem>
    );
  }

  renderActionLabel = (action) => {
    let style = "default";
    switch(action) {
      case Action.Create: style = "primary"; break;
      case Action.Delete: style = "danger"; break;
      case Action.Denied: style = "warning"; break;
      case Action.Unlock: style = "success"; break;
      case Action.Update: style = "default"; break;
      case Action.Call: style = "info"; break;
      default: style = "default";
    }
    return (
      <Label bsStyle={style}>{action}</Label>
    )
  }

  onClick = (e) => {
    e.preventDefault();

    const {
      log,
      onClick
    } = this.props;

    if (onClick) {
      onClick(log);
    }

    return false;
  }
});

export default LogList;


// WEBPACK FOOTER //
// ./src/components/Log/LogList.js